import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductCard from '../../components/ProductCard';
import Filters from '../../components/Filters';
import Pagination from '../../components/Pagination';
import PrivateRouteB2B from '../../components/PrivateRouteB2B';

const LIMIT = 15;

const ProductsB2b = () => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState('tous'); // toujours en minuscule
  const [searchTerm, setSearchTerm] = useState('');
  const [country, setCountry] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);

  // reset page quand les filtres changent
  useEffect(() => {
    setPage(1);
  }, [selected, searchTerm, country]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    setLoading(true);

    const params = {
      page,
      limit: LIMIT,
      searchTerm,
      country,
    };
    if (selected !== 'tous') params.type = selected; // ne pas envoyer "tous"

    axios
      .get(`/api/products/paginate`, {
        params,
        cancelToken: source.token,
      })
      .then((res) => {
        setProducts(res.data?.products || []);
        setTotalPages(res.data?.totalPages || 1);
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          console.error('Erreur chargement produits :', err);
          setProducts([]);
        }
      })
      .finally(() => setLoading(false));

    return () => source.cancel('route change');
  }, [page, selected, searchTerm, country]);

  return (
    <PrivateRouteB2B>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center my-5"
          style={{ minHeight: 800 }}
        >
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: '3rem', height: '3rem' }}
          />
        </div>
      ) : (
        <div className="container my-4">
          <Filters
            selected={selected}
            setSelected={setSelected}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            country={country}
            setCountry={setCountry}
          />

      
            {!loading && products.length === 0 ? (
              <div className="alert alert-danger" role="alert" style={{marginBottom: '300px'}}>Aucun produit trouvé.</div>
            ) : (
              <div className="all-container">
              {products.map((prod) => (
                <div
                  className="cardB2b"
                  key={prod._id}
                >
                  <ProductCard product={prod} />
                </div>
              ))}
              </div>
            )}
          

          <Pagination totalPages={totalPages} page={page} setPage={setPage} />
        </div>
      )}
    </PrivateRouteB2B>
  );
};

export default ProductsB2b;
